document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined') return;

    document.querySelectorAll('.circular-text').forEach(el => {
        const duration = parseFloat(el.dataset.duration) || 12;

        gsap.to(el, {
            rotation: 360,
            duration,
            repeat: -1,
            ease: 'none',
            transformOrigin: '50% 50%',
        });
    });
});
